import { createBrowserRouter } from 'react-router';
import HomePage from '@/pages/home/HomePage';
import IntroPage from '@/pages/intro/IntroPage';
import PricePage from '@/pages/price/PricePage';
import MainLayout from '@/layout/MainLayout';
import PromotionPage from '@/pages/promotion/PromotionPage';
import { ROUTER_PATH, ROUTER_TITLES } from '@/router/constants';
import { CustomerSupportRouter } from '@/router/CustomerSupport';
import { InquiryRouter } from '@/router/Inquiry';
import { FunctionRouter } from '@/router/Function';
import { PrivacyRouter, TermsRouter } from '@/router/Policy';
import { ConsultingRouter } from '@/router/Consulting';
import ErrorPage from '@/pages/error/ErrorPage';
import ConsultingPage from '@/pages/consulting/ConsultingPage';
import WhyPage from '@/pages/why/whyPage';

export const routes = [
	{
		path: ROUTER_PATH.HOME,
		element: <MainLayout />,
		errorElement: <ErrorPage />,
		title: ROUTER_TITLES.MAIN,
		children: [
			{
				index: true,
				element: <HomePage />,
				title: ROUTER_TITLES.MAIN
			}
		]
	},
	{
		path: ROUTER_PATH.BASE,
		element: <MainLayout />,
		errorElement: <ErrorPage />,
		title: ROUTER_TITLES.MAIN,
		children: [
			{
				path: ROUTER_PATH.INTRO,
				element: <IntroPage />,
				title: ROUTER_TITLES.INTRO
			},
			{
				path: ROUTER_PATH.WHY,
				element: <WhyPage />,
				title: ROUTER_TITLES.INTRO
			},
			{
				path: ROUTER_PATH.PRICE,
				element: <PricePage />,
				title: ROUTER_TITLES.PRICE
			},
			{
				path: ROUTER_PATH.CONSULTING,
				element: <ConsultingPage />,
				title: ROUTER_TITLES.CONSULTING
			},
			{
				path: ROUTER_PATH.PROMOTION,
				element: <PromotionPage />,
				title: ROUTER_TITLES.PROMOTION
			},
			FunctionRouter,
			CustomerSupportRouter,
			InquiryRouter,
			TermsRouter,
			PrivacyRouter
		]
	}
];

const router = createBrowserRouter(routes);

export default router;
